import { render, staticRenderFns } from "./RedirectToOpenBankingPopup.vue?vue&type=template&id=8cd88614&scoped=true"
import script from "./RedirectToOpenBankingPopup.vue?vue&type=script&lang=js"
export * from "./RedirectToOpenBankingPopup.vue?vue&type=script&lang=js"
import style0 from "./RedirectToOpenBankingPopup.vue?vue&type=style&index=0&id=8cd88614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd88614",
  null
  
)

export default component.exports